import { createSelector } from 'reselect'
import { getArrayOfObjectValues } from '../../utils';

export const getCompanySelector = createSelector(
  company => company.company,
  (companyById) => getArrayOfObjectValues(companyById)
);